import { render, staticRenderFns } from "./DeviceStats.vue?vue&type=template&id=251c80bd&scoped=true&"
import script from "./DeviceStats.vue?vue&type=script&lang=js&"
export * from "./DeviceStats.vue?vue&type=script&lang=js&"
import style0 from "./DeviceStats.vue?vue&type=style&index=0&id=251c80bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251c80bd",
  null
  
)

export default component.exports